import { Layout } from '@community_dev/pixels'
import { Button, Card, Typography } from 'antd'
import type { JSX } from 'react'
import { useHistory } from 'react-router'

import { ROUTES } from 'constants/routes'
import { useCreateSSOConfigMutation } from 'hooks/useSSOConfigMutation'
import { SSOConfigForm } from 'screens/Clients/Client/components/SSO/SSOConfigForm'
import { SidebarLayout } from 'shared/layouts'
import { route } from 'utils/router'

export function SSOConfigCreate(): JSX.Element {
  const history = useHistory()
  const { mutateAsync: createSSOConfig, isLoading: isCreating, error } = useCreateSSOConfigMutation()

  return (
    <SidebarLayout>
      <Layout padding="12px">
        <Card
          bordered
          extra={<Button onClick={() => history.push(ROUTES.SSO_CONFIGS)}>Back to list</Button>}
          title={
            <Layout padding="12px 0">
              <Typography.Title level={4} style={{ margin: 0 }}>
                SSO Configs
              </Typography.Title>
              <Typography.Text type="secondary">New</Typography.Text>
            </Layout>
          }
        >
          <Typography.Title level={4}>Create SSO Config</Typography.Title>
          <SSOConfigForm
            error={error}
            isSaving={isCreating}
            onSubmit={async (values) => {
              const resp = await createSSOConfig(values)
              const id = resp?.data?.id
              if (id) history.push(route(ROUTES.SSO_CONFIG, { id }))
            }}
            showDelete={false}
          />
        </Card>
      </Layout>
    </SidebarLayout>
  )
}
